<template>
  <div class="route-bar grid" style="min-height: 2em;">
    <div class="col-6">
      <div class="route-bar-breadcrumb" style="width: 100%;padding: 0;">
        <ul style="position: absolute;top: 86px;margin-left: 1em;">
          <li v-if="$route.path === '/'">Dashboard</li>
          <template v-else v-for="(path,i) of $route.path.split('/')">
            <li :key="'d_'+i" v-if="$route.path !== '/' && path === ''" />
            <li :key="'r_'+i" v-else>{{ $t($route.name + '.breadcrumb') }}</li>
          </template>
        </ul>
        <div style="float: right; color: white;" v-if="selectedPortfolio">{{ selectedPortfolio.id }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  beforeMount() {
  },
  data() {
    return {
      processedBuyers: 0,
      inErrorBuyers: 0,
    };
  },
  computed: {
    selectedPortfolio() {
      return this.$store.getters['selectedPortfolio'];
    },
  },
  watch: {},
  methods: {
    home() {
      window.location = '/#/';
    },
  },
};
</script>

<style scoped>

</style>
